var map = {
	"./beats/beats.module": [
		"./src/app/beats/beats.module.ts",
		"beats-beats-module"
	],
	"./browser/browser.module": [
		"./src/app/browser/browser.module.ts",
		"browser-browser-module"
	],
	"./music/music.module": [
		"./src/app/music/music.module.ts",
		"music-music-module"
	],
	"./news/news.module": [
		"./src/app/news/news.module.ts",
		"news-news-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;